import { Stack, Box, Typography, Button, useMediaQuery, useTheme, Alert, AlertTitle } from "@mui/material";
import { DoktorFooter } from "./components/DoktorFooter";
import { DoktorLinearBar } from "./components/DoktorLinearBar";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import FaceScanInstruction from '../../components/faceScanInstruction/faceScanInstruction';

export const DoktorPreFaceScan = () => {
	const theme = useTheme();
	const [ currentStep, setCurrentStep ] = useState(7);
	const { isFaceScanFailed } = location.state || {};
	const isLaptop = useMediaQuery(theme.breakpoints.up('md'));
	const navigate = useNavigate();
	const [error, setError] = useState(null);
	const isSmallHeight = useMediaQuery('(max-height:700px)');
	const [showBrightnessInstructionScreen, setIsShowBrightnessInstructionScreen] = useState(false);
	useEffect(() => {
		if (!isFaceScanFailed) {
			try {
				const redirectUrl = localStorage.getItem('doktor-redirect-url');
				if (!redirectUrl) {
					setError('Missing redirect URL. Please complete the demographics form first.');
					navigate('/doktor-demographic');
				}
			} catch (err) {
				setError('Failed to access local storage. Please try again.');
			}
		}
	}, [navigate, isFaceScanFailed]);

	const handleLetsGo = () => {
		try {
			localStorage.setItem('post-scan-redirect', '/doktor-symptom-checker');
			const redirectUrl = localStorage.getItem('doktor-redirect-url');

			if (redirectUrl) {
				window.localStorage.setItem('from_doktor', 'true');
				window.location.href = redirectUrl;
			} else {
				throw new Error('Redirect URL not found');
			}
		} catch (err) {
			setError('Failed to proceed. Please try again.');
		}
	};


	const handleNext = () => {
		setCurrentStep( prev => prev + 1 );
		setIsShowBrightnessInstructionScreen(true)
	}

	const handleDismissError = () => {
		setError(null);
	};

	const handleHomeClick = () => {
		navigate('/doktorlanding');
	};

	return (
		<Box
			sx={{
				height: isLaptop ? '100vh' : ( isSmallHeight ? "85vh" : "90vh" ),
				display: 'flex',
				flexDirection: 'column',
				maxWidth: isLaptop ? '1200px' : '100%',
				margin: '0 auto',
				padding: isLaptop ? '24px' : '16px',
				boxSizing: 'border-box',
				position: 'relative'
			}}
		>
			{/* Error Alert */}
			{error && (
				<Box sx={{
					position: 'fixed',
					top: 16,
					left: '50%',
					transform: 'translateX(-50%)',
					width: '90%',
					maxWidth: '600px',
					zIndex: 1000
				}}>
					<Alert
						severity="error"
						variant="filled"
						onClose={handleDismissError}
						sx={{ mb: 2 }}
						action={
							<Button
								color="inherit"
								size="small"
								onClick={handleHomeClick}
								sx={{
									textDecoration: 'underline',
									'&:hover': {
										textDecoration: 'none'
									}
								}}
							>
								Return Home
							</Button>
						}
					>
						<AlertTitle>Error</AlertTitle>
						{error}
					</Alert>
				</Box>
			)}

			<Stack
				className="doktor-symptoms"
				sx={{
					flex: 1,
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'space-between',
					maxWidth: isLaptop ? '800px' : '100%',
					width: '100%',
					margin: '0 auto',
				}}
			>
				{/* Header */}
				<Box className='doktor-header'>
					<DoktorLinearBar value={ ( currentStep ) * ( 100 / 12) } />
				</Box>

				{/* Body */}
				{!showBrightnessInstructionScreen ? <Box
					className='doktor-body'
					sx={{
						flexGrow: 1,
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center',
						paddingX: isLaptop ? 8 : 2,
					}}
				>
					<Typography
						color="#232A67"
						sx={{
							fontSize: isLaptop ? '36px' : '24px',
							fontWeight: '700',
							lineHeight: 1.2,
							textAlign: 'center',
							my: 2,
						}}
					>
						Now, we will scan your face to measure your biomarkers. 
					</Typography>

					<Typography
						color="#232A67"
						sx={{
							fontSize: isLaptop ? '16px' : '14px',
							fontWeight: '400',
							lineHeight: 1.5,
							textAlign: 'center',
							mb: 2,
						}}
					>
						Based on these results, we can curate product recommendations  that will work specifically for you.
						{/* <strong>Heart rate variability (HRV)</strong> is related to stress, aging, and other metrics of physical and mental health. */}
					</Typography>

					<Typography
						color="#232A67"
						sx={{
							fontSize: isLaptop ? '16px' : '14px',
							fontWeight: '400',
							lineHeight: 1.5,
							textAlign: 'center',
							mb: 2,
						}}
					>
						 💡 Please make sure you are in a brightly lit area and the light is spread evenly on your face.
					</Typography>

					<Typography
						color="#232A67"
						sx={{
							fontSize: isLaptop ? '16px' : '14px',
							fontWeight: '400',
							lineHeight: 1.5,
							textAlign: 'center',
							mb: 3,
						}}
					>
					  Remove your hat and eyeglasses and stay close to the camera and still during the 30-second scan to get a good measurement. 
					</Typography>

					<Button
						sx={{
							alignSelf: 'center',
							width: isLaptop ? '340px' : '100%',
							height: isLaptop ? '60px' : '50px',
							background: '#0633CB',
							borderRadius: '10px',
							"&:hover": {
								backgroundColor: "#0633CB",
							},
							marginTop: isLaptop ? '40px' : '20px',
						}}
						onClick={handleNext}
					>
						<Typography
							color="#FFF"
							sx={{
								fontSize: isLaptop ? '20px' : '18px',
								fontWeight: '600',
								lineHeight: 1,
							}}
						>
							Next
						</Typography>
					</Button>
				</Box>
					:
					<Box 	className='doktor-body'
					sx={{
						flexGrow: 1,
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center',
						paddingX: isLaptop ? 8 : 2,
					}}>
						<FaceScanInstruction   videoContainerSx={{marginY : { xs : isSmallHeight ? "10px" : "30px" , lg : "40px"}}} ></FaceScanInstruction>
						<Button
							sx={{
								alignSelf: 'center',
								width: isLaptop ? '340px' : '100%',
								height: isLaptop ? '60px' : '50px',
								background: '#0633CB',
								borderRadius: '10px',
								marginTop: isLaptop ? '40px' : '20px',
								"&:hover": {
									backgroundColor: "#0633CB", // prevent adding hover of othere css  
								},
							}}
							onClick={handleLetsGo}
						>
							<Typography
								color="#FFF"
								sx={{
									fontSize: isLaptop ? '20px' : '18px',
									fontWeight: '600',
									lineHeight: 1,
								}}
							>
								Let's go!
							</Typography>
						</Button>
					</Box>
				}
				{/* Footer */}
				<Box textAlign='center' maxWidth='100%' display='flex' justifyContent='center'>
					<DoktorFooter />
				</Box>
			</Stack>
		</Box>
	);
};